import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Icon from './Icons';

const StyledDropdown = styled.div`
  display: flex;
  align-items: center;
  margin-left: 7px;
  width: 9px;
  height: 5px;
  fill: ${props => props.theme.carvana.blue.dark};
`;

const DropdownArrow = ({ className }) => (
  <StyledDropdown className={className}>
    <Icon iconName="dropdownArrow" />
  </StyledDropdown>
);

DropdownArrow.defaultProps = {
  className: '',
};

DropdownArrow.propTypes = {
  className: PropTypes.string,
};

export default DropdownArrow;
